export class InfluencerNote {
  public id: number;
  public userId: number;
  public userName: string;
  public companyId: number;
  public influencerId: number;
  public content: string;
  public createdAt: Date;
  public modifiedAt: Date;
}



// WEBPACK FOOTER //
// ./src/models/influencer-note.ts